import Constants from '../config/const';
import { redo } from './undo';
import { saveWall, uploadAsset } from './save_wall';

export const removeCustomImage = () => (dispatch, getState) => {
  const {
    src, widthIn, heightIn, posX, posY
  } = getState().customImage;
  dispatch(redo({
    type: Constants.customImage.add,
    src,
    widthIn,
    heightIn,
    posX,
    posY
  }));
  dispatch({
    type: Constants.customImage.remove
  });
  dispatch(saveWall());
};

const updateSrc = (src) => ({
  type: Constants.customImage.update,
  src
});

export const addCustomImage = ({
  src, widthIn, heightIn, binaryContent
}) => (dispatch, getState) => {
  const { centerX, centerY } = getState().canvas;
  dispatch({
    type: Constants.customImage.add,
    src,
    widthIn,
    heightIn,
    posX: centerX - (widthIn / 2),
    posY: centerY - (heightIn / 2)
  });
  dispatch(redo({
    type: Constants.customImage.remove
  }));
  uploadAsset(dispatch, getState, src, binaryContent, 'custom_images').then((newSrc) => {
    const { src: prevSrc } = getState().customImage;
    if (newSrc !== prevSrc && prevSrc) {
      dispatch(updateSrc(newSrc));
      dispatch(saveWall());
    }
  });
};

export const moveCustomImage = ({ posX, posY }) => (dispatch, getState) => {
  const { posX: posXWas, posY: posYWas } = getState().customImage;
  dispatch({
    type: Constants.customImage.move,
    posX,
    posY
  });
  dispatch(redo({
    type: Constants.customImage.move,
    posX: posXWas,
    posY: posYWas
  }));
  dispatch(saveWall());
};
